import React from "react";

export interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

/**
 * TabNavigation - Reusable tab navigation component
 * Used for switching between views (Workflows/Templates, etc.)
 */
const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="su-tab-navigation">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`su-tab ${activeTab === tab.id ? "su-tab-active" : ""}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon && <span className="su-tab-icon">{tab.icon}</span>}
          <span className="su-tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;



